import React from "react";

import { AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import { Link } from "react-router-dom";
import AppBar from "src/components/AppBar/AppBar";
import { IconName } from "src/components/Icon/Icon";
import { TableActions } from "src/components/TableV2/TableActions";
import { ReportConfig } from "./definitions";
import { groupedReports, ReportFolder } from "./docs";

import * as S from "../../constants/StringConstants";
import "./Reports.scss";

const ExpandMoreIcon = () => (
  <span className="expand-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect width="24.2963" height="24.2963" fill="white" />
      <path
        d="M6.07422 9.11108L12.1483 15.1852L18.2224 9.11108"
        stroke="#717171"
        strokeWidth="3.03704"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

const ReportItem = ({ report, folder }: { report: ReportConfig; folder: ReportFolder }) => {
  return (
    <div className="report-item">
      <Link className="report-link" to={{ pathname: `/reports/${report.id}`, state: { folder } }}>
        {report.name}
      </Link>
      <TableActions
        actions={[
          { label: "Clone Report", handler: () => console.log("Clone report:", report.id) },
          { label: "Delete Report", handler: () => console.log("Delete report:", report.id) },
        ]}
      />
    </div>
  );
};

const ReportBox = ({ folder }: { folder: ReportFolder }) => {
  return (
    <Accordion defaultExpanded className="report-box__accordion">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h5" fontWeight="bold">
          {folder.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className="report-box__details">
        {folder.reports.map((report, index) => (
          <ReportItem key={index} report={report} folder={folder} />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

const Reports = () => {
  return (
    <div className="table-view__content">
      <AppBar icon={IconName.Reports} title={S.REPORTS_TITLE} />
      <div className="report-box__container">
        {groupedReports.map((folder, index) => (
          <ReportBox key={index} folder={folder} />
        ))}
      </div>
    </div>
  );
};

export default Reports;
